import { explicitMaybe } from '@execonline-inc/decoders';
import { alreadyTranslatedText } from '@execonline-inc/translations';
import { Decoder, dateISO, field, number, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../../../Resource/Decoders';
import { formTemplatesDecoder } from '../../../../../../../../Resource/FormTemplates/Decoders';
import { productLicenseResourceDecoder, shareUrlResourceDecoder } from '../../../../../../Decoders';
import { LearningCollectionPublish, LearningCollectionPublishResource } from './Types';

const learningCollectionPublishDecoder: Decoder<LearningCollectionPublish> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', alreadyTranslatedText))
  .assign('publishedAt', field('published_at', explicitMaybe(dateISO)))
  .assign('shareUrl', field('share_url', explicitMaybe(shareUrlResourceDecoder)))
  .assign('productLicense', field('product_license', explicitMaybe(productLicenseResourceDecoder)));

export const learningCollectionPublishResourceDecoder: Decoder<LearningCollectionPublishResource> =
  resourceDecoder(learningCollectionPublishDecoder).assign('templates', ({ links }) =>
    field('templates', formTemplatesDecoder(links)),
  );
